import { useQueryClient } from '@tanstack/react-query';

import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

interface DeleteTrustedContactParams {
    userId: string;
}

const useDeleteTrustedContact = (
    options?: Parameters<
        ReturnType<
            typeof requestBuilder.mutation<
                GeneralResponse,
                null,
                DeleteTrustedContactParams
            >
        >
    >[0],
) => {
    const queryClient = useQueryClient();

    return requestBuilder.mutation<
        GeneralResponse,
        null,
        DeleteTrustedContactParams
    >({
        endpoint: ({ userId }) => `/api/user/${userId}/trusted-contacts`,
        method: 'DELETE',
    })({
        ...options,
        onSuccess: async (data, variables, context, mutation) => {
            await queryClient.invalidateQueries({
                queryKey: [`getTrustedContact-${variables.urlParams?.userId}`],
            });
            await options?.onSuccess?.(data, variables, context, mutation);
        },
    });
};

export default useDeleteTrustedContact;
